// extracted by mini-css-extract-plugin
export default {"container":"_1oTr","text":"_1KBI","myText":"_2Rt1","opponentText":"_1Xoy","extraInfo":"_13Ha","applicantExtraInfo":"_1SVz","extraInfoIcon":"_3Mwb"};